export enum FeatureFlag {
  ALLOW_OM_CREATE_NEW_FILE = 'ordermanagement-2346561-ui-create-new-file',
  SHOW_EMAIL_IN_ORDER_INSIGHTS = 'marketplace-2394550-verify-by-email',
  SHOW_FINCEN_REPORTING_NAVIGATION = 'fincenreporting-ans-001812-feature-enabled',
  SHOW_FSC_TAB = 'ordermanagement-ans-1679-ui-fsc-tab',
  SHOW_COVER_SHEET_OPTION = 'service-order-001896-cover-sheet-option-enabled',
  FINCEN_GENERATE_BUTTON_ENABLED = 'fincenreporting-ans-005886-generate-button-enabled',
  FINCEN_TCC_FIELD_ENABLED = 'fincenreporting-ans-007339-tcc-field-enabled',
  APPROVED_ATTORNEY_ROLE_RESTRICTIONS = 'roles-ans-6600-approved-attorney-enabled',
  SERVICE_ORDER_WIRE_PAYMENT_ENABLED = 'service-order-ans-870-wire-payment-enabled',
  INCLUDE_AGENT_NET_DATA_INVOICING = 'ordermanagement-ans-8046-include-agent-net-data-invoicing',
  SHOW_AUTOPAY = 'auto-pay-ans-8412-autopay-enabled',
  EULA_REACCEPTANCE_ENABLED = 'eula-ans-8377-reacceptance-enabled',
  SHOW_IDV_NAME_MATCH = 'idv-ans-8817-name-match',
  SERVICE_ORDER_ANS_7540_AMEND_CLOSED_FILES = 'service-order-ans-7540-amend-closed-files',
  SHOW_FINCEN_IN_ORDER_INSIGHTS = 'order-insights-ans-9420-fincen-enabled',
  JACKET_ANS_9276_PREVENT_WITH_STANDALONE_ENDORSEMENT = 'jackets-ans-9276-prevent-jacket-standalone-endorsement',
  JACKET_ANS_9001_REMOVE_COMPLIANCE_DATE_FUTURE_BLOCK = 'jacket-ans-9001-remove-compliance-date-future-block',
  TITLE_MONITORING_ENABLED = 'title-monitoring-ans-10073-feature-enabled',
  TITLE_MONITORING_FIRM_ADMIN_ENABLED = 'title-monitoring-ans-10073-firm-admin-enabled',
  SERVICE_ORDER_ANS_11273_WIRE_TRANSMITTAL_ICON_ENABLED = 'service-order-ans-11273-wire-transmittal-icon-enabled',
  NON_FA_UW_ANS_679_ENABLED = 'non-fa-uw-ans-679-enabled',
  PREFERRED_OFFICE_FILTERING = 'files-ans-10718-preferred-office-filtering',
}
